<template>
    <el-dialog custom-class="dialogForm" class="measDialog" :visible.sync="visible" :before-close="handleClose" :close-on-click-modal="false" width="80%" :title="title">
        <el-scrollbar class="dialogContentScroll">
            <el-form :model="form" ref="form" :rules="rules">
                <el-form-item label="题库名称" prop="subject">
                    <el-input v-model="form.subject" maxlength="50" show-word-limit placeholder="请输入" clearable></el-input>
                </el-form-item>
                <el-form-item label="题库简介" prop="description">
                    <el-input v-model="form.description" maxlength="100" show-word-limit placeholder="请输入" clearable></el-input>
                </el-form-item>
                <el-form-item label="选择试卷" prop="exampapername">
                    <!-- <ChoicePapers ref="ChoicePapers"></ChoicePapers> -->
                    <el-select v-model="form.exampapername" @focus="openChoicePapers" clearable></el-select>
                </el-form-item>
                <el-form-item label="题库封面" prop="logoid">
                    <div class="flex al-c">
                        <div class="uploadItem">
                            <UploadFile ref="uploadFile" accept=".png,.jpg,.jepg" :show-file-list="false" :fileMaxSize="5120" :scope-type="106" @success="coverattUploadSuccess">
                                <div class="noCoveratturl" v-if="!form.coverurl">
                                    <i class="el-icon-plus"></i>
                                    <div class="label">上传图片</div>
                                </div>
                                <div v-else style="position: relative;">
                                    <img class="coveratturl" :src="form.coverurl + '?v=' + now" alt="">
                                    <div class="del" @click.stop="deletImg">
                                        x
                                    </div>
                                </div>
                            </UploadFile>
                        </div>
                        <div class="flex al-c">
                            <p class="imgdesp">建议尺寸 180*180px，JPG、PNG 格式， 图片小于 5M。</p>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="题库详情" prop="content">
                    <UEditor ref="uEditor"></UEditor>
                </el-form-item>
            </el-form>
        </el-scrollbar>
        <div slot="footer" style="text-align:right">
            <el-button @click="handleClose">取 消</el-button>
            <el-button type="primary" :loading="isLoading" @click="saveQuestionbank(0)" plain>保存为草稿</el-button>
            <el-button type="primary" :loading="isLoading" @click="saveQuestionbank(1)">保存并发布</el-button>
        </div>
        <ChoicePapers ref="ChoicePapers" @affirmChoicePapers="getPapers"></ChoicePapers>
    </el-dialog>
</template>
<script>
import {
  getQuestionbankDetails,
  saveQuestionbank
} from '@/api/measApi/questionManage.js'
import UploadFile from '@/components/measComponents/uploadFile/uploadFile.vue'
import UEditor from '@/components/measComponents/uEditor/uEditor.vue'
import ChoicePapers from '@/components/measComponents/choicePapers/choicePapers.vue'
export default {
  data() {
    return {
      visible: false,
      title: '新增题库',
      form: {
        content: '', // 题库详情
        coverid: '', // 封面LogoID
        coverurl: '', // 题库封面logourl
        code: '',
        description: '', // 题库简介
        exampaperinnerid: '', // 试卷code
        exampapername: '', // 试卷名称
        savetype: 0, // 0草稿 1 保存提交
        subject: '' // 题库名称
      },
      rules: {
        subject: [
          { required: true, message: '请输入题库名称', trigger: 'blur' }
        ],
        exampapername: [
          { required: true, message: '请选择试卷', trigger: 'change' }
        ]
      },
      uploadType: {
        catecode: 106,
        datatype: 'IMAGE',
        attid: '',
        url: ''
      },
      orgForm: {},
      isLoading: false,
      now: new Date().getTime(),
      papersObj: {}
    }
  },
  components: {
    UploadFile,
    UEditor,
    ChoicePapers
  },
  methods: {
    handleOpen(code) {
      this.visible = true
      this.orgForm = JSON.parse(JSON.stringify(this.form))
      if (code) {
        this.title = '编辑题库'
        getQuestionbankDetails({ code: code }).then(res => {
          if (res.code === '000') {
            this.form = res.data
            this.$refs.uEditor.detail = this.form.content
          }
        })
      } else {
        this.title = '新增题库'
      }
    },
    // 上传成功
    coverattUploadSuccess(file) {
      this.form.coverid = file.key
      this.form.coverurl = file.atturl
      this.now = new Date().getTime()
    },
    // 删除照片
    deletImg() {
      this.form.coverid = ''
      this.form.coverurl = ''
    },
    // 打开选择试卷
    openChoicePapers() {
      this.$refs.ChoicePapers.openDialog()
    },
    // 获取选中的试卷
    getPapers(args) {
      this.form.exampaperinnerid = args[0].exampaperinnerid
      this.form.exampapername = args[0].exampapername
      this.papersObj = args
    },
    // 保存
    saveQuestionbank(args) {
      this.$refs.form.validate(validate => {
        if (validate) {
          this.isLoading = true
          this.form.content = this.$refs.uEditor.detail
          this.form.savetype = args
          saveQuestionbank(this.form).then(res => {
            if (res.code === '000') {
              this.$message.success(res.msg)
              this.$emit('saveSuccess')
              this.isLoading = false
              this.handleClose()
            }
          })
        }
      })
    },
    handleClose() {
      if (this.isLoading) {
        this.$message.warning('提交数据中，请稍等')
        return
      }
      this.visible = false
      this.form = this.orgForm
      this.$refs.uploadFile.clearFiles()
      this.$refs.form.clearValidate()
    }
  }
}
</script>
<style lang="scss" scoped>
.uploadItem {
  margin-right: 10px;
  width: 80px;
  height: 80px;
  .noCoveratturl {
    cursor: pointer;
    width: 80px;
    height: 80px;
    background: #d9d9d9;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .el-icon-plus {
      font-size: 20px;
      color: #fff;
    }
    .label {
      font-size: 12px;
      color: #666666;
      line-height: 24px;
    }
  }
  .coveratturl {
    width: 80px;
    height: 80px;
    cursor: pointer;
  }
  .del {
    position: absolute;
    right: -7px;
    top: -9px;
    background-color: #e66271;
    width: 18px;
    height: 18x;
    border-radius: 50%;
    line-height: 18px;
    font-size: 13px;
    cursor: pointer;
    color: #fff;
    z-index: 22;
  }
}
.imgdesp {
  font-size: 14px;
  line-height: 80px;
  color: #d8d8d8;
}
</style>

